module.exports = __webpack_public_path__ + "static/img/swiper1.aff08ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swiper1.jpg
// module id = AfDF
// module chunks = 1